import { Dropzone, type Props as DropzoneProps } from '@components/dropzone/Dropzone'
import type { FieldValues, Path } from 'react-hook-form'
import { Controller, useFormContext } from 'react-hook-form'

type Props<T extends FieldValues> = Pick<
  DropzoneProps<T>,
  'label' | 'supportedFileTypesLabel' | 'disabled' | 'disabledTooltipText' | 'renderPostUploadContent' | 'multiple'
> & {
  name: Path<T>
}

export const FormDropzone = <T extends FieldValues>({ name, ...rest }: Props<T>) => {
  const { control } = useFormContext<T>()

  return (
    <Controller<T>
      control={control}
      name={name}
      render={({ field }) => (
        <Dropzone
          {...rest}
          field={field}
        />
      )}
    />
  )
}
